const SaveOfficeAction = {
    Request: 'SaveOfficeActionRequest',
    Success: 'SaveOfficeActionSuccess',
    Failure: 'SaveOfficeActionFailure',
}

const FetchOfficesAction = {
    Request: 'FetchOfficesActionRequest',
    Success: 'FetchOfficesActionSuccess',
    Failure: 'FetchOfficesActionFailure',
}

const GetOfficeAction = {
    Request: 'GetOfficeActionRequest',
    Success: 'GetOfficeActionSuccess',
    Failure: 'GetOfficeActionFailure',
}

const UnloadOfficeAction = {
    Request: 'UnloadOfficeActionRequest',
    Success: 'UnloadOfficeActionSuccess',
}

const UpdateOfficeAction = {
    Request: 'UpdateOfficeActionRequest',
    Success: 'UpdateOfficeActionSuccess',
    Failure: 'UpdateOfficeActionFailure',
}

function saveOffice(office) {
    return {
        type: SaveOfficeAction.Request,
        payload: office
    }
}

function fetchOffices(page = 0, size = 20) {
    return {
        type: FetchOfficesAction.Request,
        payload: {
            page, size
        }
    }
}

function getOffice(id) {
    return {
        type: GetOfficeAction.Request,
        payload: id
    }
}

function unloadOffice() {
    return {
        type: UnloadOfficeAction.Request
    }
}

function updateOffice(office) {
    return {
        type: UpdateOfficeAction.Request,
        payload: office
    }
}

export const OfficeActionCreators = {
    saveOffice,
    fetchOffices,
    getOffice,
    unloadOffice,
    updateOffice
}

export const OfficeActions = {
    SaveOfficeAction,
    FetchOfficesAction,
    GetOfficeAction,
    UnloadOfficeAction,
    UpdateOfficeAction
}